import styled from 'styled-components'

export const Container = styled.div`
  margin-top:30px;
  width:90%;
  margin-left:5%;
  margin-bottom:100px;
  th:{
    text-align:center!important;
  }
`

export const TituloGuia = styled.p`
  font-size:24px;
  position:relative;
  top:24px;
  font-weight:800
`

export const CenterText = styled.span`
  text-align:center!important;
`